import { authenticateUser, logoutUser } from "./oidc-service.js";
export const oidcReducer = (state, action) => {
  switch (action.type) {
    case 'ON_ERROR':
      return {
        ...state,
        error: action.message,
        isLoading: false
      };
    case 'ON_LOADING':
      return {
        ...state,
        isLoading: true
      };
    case 'ON_LOAD_USER':
      return {
        ...state,
        oidcUser: action.user,
        isLoading: false
      };
    case 'ON_UNLOAD_USER':
      return {
        ...state,
        oidcUser: undefined,
        isLoading: false
      };
    default:
      return state;
  }
};
export const logout = (userManager, dispatch) => async () => {
  try {
    await logoutUser(userManager);
  } catch (error) {
    onError(dispatch, error);
  }
};
export const login = (userManager, dispatch, location, history) => async () => {
  dispatch({
    type: 'ON_LOADING'
  });
  await authenticateUser(userManager, location, history)();
};
export const onError = (dispatch, error) => {
  dispatch({
    type: 'ON_ERROR',
    message: error.message
  });
};
export const onUserLoaded = (dispatch, user) => {
  dispatch({
    type: 'ON_LOAD_USER',
    user
  });
};
export const onUserUnloaded = dispatch => {
  dispatch({
    type: 'ON_UNLOAD_USER'
  });
};
export const onAccessTokenExpired = async (dispatch, userManager) => {
  dispatch({
    type: 'ON_UNLOAD_USER'
  });
  await userManager.signinSilent();
};
export const addOidcEvents = ({
  dispatch,
  userManager,
  customEvents
}) => {
  userManager.events.addUserLoaded(user => {
    var _customEvents$onUserL;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserL = customEvents.onUserLoaded) === null || _customEvents$onUserL === void 0 ? void 0 : _customEvents$onUserL.call(customEvents, user);
    onUserLoaded(dispatch, user);
  });
  userManager.events.addSilentRenewError(error => {
    var _customEvents$onSilen;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onSilen = customEvents.onSilentRenewError) === null || _customEvents$onSilen === void 0 ? void 0 : _customEvents$onSilen.call(customEvents, error);
    onError(dispatch, error);
  });
  userManager.events.addUserUnloaded(() => {
    var _customEvents$onUserU;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserU = customEvents.onUserUnloaded) === null || _customEvents$onUserU === void 0 ? void 0 : _customEvents$onUserU.call(customEvents);
    onUserUnloaded(dispatch);
  });
  userManager.events.addUserSignedOut(() => {
    var _customEvents$onUserS;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserS = customEvents.onUserSignedOut) === null || _customEvents$onUserS === void 0 ? void 0 : _customEvents$onUserS.call(customEvents);
    onUserUnloaded(dispatch);
  });
  userManager.events.addAccessTokenExpired(() => {
    var _customEvents$onAcces;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onAcces = customEvents.onAccessTokenExpired) === null || _customEvents$onAcces === void 0 ? void 0 : _customEvents$onAcces.call(customEvents);
    onAccessTokenExpired(dispatch, userManager);
  });
  if (customEvents !== null && customEvents !== void 0 && customEvents.onAccessTokenExpiring) {
    userManager.events.addAccessTokenExpiring(customEvents.onAccessTokenExpiring);
  }
  if (customEvents !== null && customEvents !== void 0 && customEvents.onUserSessionChanged) {
    userManager.events.addUserSessionChanged(customEvents.onUserSessionChanged);
  }
};
export const removeOidcEvents = ({
  dispatch,
  userManager,
  customEvents
}) => {
  userManager.events.removeUserLoaded(user => {
    var _customEvents$onUserL2;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserL2 = customEvents.onUserLoaded) === null || _customEvents$onUserL2 === void 0 ? void 0 : _customEvents$onUserL2.call(customEvents, user);
    onUserLoaded(dispatch, user);
  });
  userManager.events.removeSilentRenewError(error => {
    var _customEvents$onSilen2;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onSilen2 = customEvents.onSilentRenewError) === null || _customEvents$onSilen2 === void 0 ? void 0 : _customEvents$onSilen2.call(customEvents, error);
    onError(dispatch, error);
  });
  userManager.events.removeUserUnloaded(() => {
    var _customEvents$onUserU2;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserU2 = customEvents.onUserUnloaded) === null || _customEvents$onUserU2 === void 0 ? void 0 : _customEvents$onUserU2.call(customEvents);
    onUserUnloaded(dispatch);
  });
  userManager.events.removeUserSignedOut(() => {
    var _customEvents$onUserS2;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onUserS2 = customEvents.onUserSignedOut) === null || _customEvents$onUserS2 === void 0 ? void 0 : _customEvents$onUserS2.call(customEvents);
    onUserUnloaded(dispatch);
  });
  userManager.events.removeAccessTokenExpired(() => {
    var _customEvents$onAcces2;
    customEvents === null || customEvents === void 0 ? void 0 : (_customEvents$onAcces2 = customEvents.onAccessTokenExpired) === null || _customEvents$onAcces2 === void 0 ? void 0 : _customEvents$onAcces2.call(customEvents);
    onAccessTokenExpired(dispatch, userManager);
  });
  if (customEvents !== null && customEvents !== void 0 && customEvents.onAccessTokenExpiring) {
    userManager.events.removeAccessTokenExpiring(customEvents.onAccessTokenExpiring);
  }
  if (customEvents !== null && customEvents !== void 0 && customEvents.onUserSessionChanged) {
    userManager.events.removeUserSessionChanged(customEvents.onUserSessionChanged);
  }
};
//# sourceMappingURL=oidc-events.js.map